/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDownloadLink = makeDownloadLink;
exports.triggerDownload = triggerDownload;
exports.mergeCanvasAndImage = mergeCanvasAndImage;
function makeDownloadLink(link, _ref) {
  var OrginalImage = _ref.OrginalImage,
      canvas = _ref.canvas,
      originalFileName = _ref.originalFileName;

  // Download button
  function downloadImage(e) {
    e.preventDefault();
    triggerDownload(canvas, originalFileName, OrginalImage);
  }
  link.addEventListener("click", downloadImage);
}

function nope(e) {
  console.log(e);
}
var downloadCounter = 0;
function triggerDownload(canvas, originalFileName, OrginalImage) {
  var failed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : nope;
  var suceeded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : nope;

  var filename = originalFileName + "-minimage-" + downloadCounter + ".png";
  mergeCanvasAndImage(canvas, OrginalImage, failed, suceeded);
  downloadCanvas(canvas, filename, failed, suceeded);

  downloadCounter++;
}

function mergeCanvasAndImage(canvas, img, failed, suceeded) {
  try {
    // Pastes the image as a canvas background
    var ctx = canvas.getContext("2d");
    var oldComposite = ctx.globalCompositeOperation;
    ctx.globalCompositeOperation = "destination-over";

    // Draw the orignal image
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    ctx.globalCompositeOperation = oldComposite;
    suceeded && setTimeout(suceeded);
    return canvas;
  } catch (e) {
    failed && failed(e);
  }
}

function downloadCanvas(canvas, filename, failed, suceeded) {
  try {
    canvas.toBlob(function (blob) {
      try {
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, filename);
          suceeded && setTimeout(suceeded);
        } else {
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a");
          document.body.appendChild(link);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.click();
          suceeded && setTimeout(suceeded);
          setTimeout(function () {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }, 3000);
        }
      } catch (e) {
        failed && failed(e);
      }
    });
  } catch (e) {
    failed && failed(e);
  }
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3);

var _colorPicker = __webpack_require__(4);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _getAnImage = __webpack_require__(9);

var _getAnImage2 = _interopRequireDefault(_getAnImage);

var _toggleAbleBackground = __webpack_require__(10);

var _toggleAbleBackground2 = _interopRequireDefault(_toggleAbleBackground);

var _editableCanvas = __webpack_require__(11);

var _editableCanvas2 = _interopRequireDefault(_editableCanvas);

var _canvasMergerAndDonwloaderLink = __webpack_require__(0);

var _pencilSizeSlider = __webpack_require__(12);

var _pencilSizeSlider2 = _interopRequireDefault(_pencilSizeSlider);

var _welcomeAnim2 = __webpack_require__(13);

var _welcomeAnim3 = _interopRequireDefault(_welcomeAnim2);

var _spinners = __webpack_require__(14);

var _detectCtrlS = __webpack_require__(15);

var _runtime = __webpack_require__(16);

var OfflinePluginRuntime = _interopRequireWildcard(_runtime);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var byId = document.getElementById.bind(document);

OfflinePluginRuntime.install();

var originalFileName = void 0,
    OrginalImage = void 0;
(0, _getAnImage2.default)({
  fileinput: byId("fileinput"),
  onImageCreated: function onImageCreated(img, filename) {
    originalFileName = filename;
    letUserDrawAndDownload(img);
  },
  startTask: _spinners.startTask,
  endTask: _spinners.endTask
});

var _welcomeAnim = (0, _welcomeAnim3.default)(byId("welcome"), { fitWindow: true }),
    stopAnim = _welcomeAnim.stopAnim,
    bgColor = _welcomeAnim.bgColor;

byId("fileInputWrapper").style.color = bgColor;

// Lets the user draw on the loaded image
function letUserDrawAndDownload(img) {
  OrginalImage = img;
  stopAnim();
  var canvas = byId("drawzone"),
      drawzoneWrapper = byId("drawzoneWrapper");

  // Switch to drawing mode
  byId("inputForAFile").style.display = "none";
  byId("drawAndDownload").style.display = "";

  console.log(img.width, img.height);
  var maxRes = Math.max(window.innerWidth, window.innerHeight) * 2;
  // Fits the canvas to screen
  var imgScale = Math.max(img.width / maxRes, img.height / maxRes, 1);
  img.width = canvas.width = img.width / imgScale;
  img.height = canvas.height = img.height / imgScale;
  drawzoneWrapper.style.maxWidth = img.width;
  drawzoneWrapper.style.maxHeight = img.height;

  // Needs to happen AFTER size measurements
  drawzoneWrapper.appendChild(img);

  var ctx = canvas.getContext("2d");
  var hasDoneFirstDraw = false;
  var barClass = byId("topbar").classList;

  var background = byId("background");

  var _setupColorPicker = (0, _colorPicker2.default)(byId("pensizePreview"), {
    canvasForCursor: canvas,
    onColorChange: setColor,
    elementToContrastWith: background
  }),
      setColorDotSize = _setupColorPicker.setColorDotSize,
      refreshColorPreviewBorder = _setupColorPicker.refreshColorPreviewBorder,
      clearColorPicker = _setupColorPicker.clearColorPicker;

  var _setupEditableCanvas = (0, _editableCanvas2.default)(canvas, {
    onMouseDown: function onMouseDown() {
      if (canvas.getClientRects()[0].height + 2 * 80 > window.innerHeight) {
        barClass.add("drawInProgress");
      }
    },
    onMouseUp: function onMouseUp() {
      if (!hasDoneFirstDraw) {
        hasDoneFirstDraw = true;
        download.classList.add("usable");
      }
      barClass.remove("drawInProgress");
    },

    OrginalImage: OrginalImage
  }),
      drawWithColor = _setupEditableCanvas.drawWithColor,
      drawWithEraser = _setupEditableCanvas.drawWithEraser,
      setPencilSize = _setupEditableCanvas.setPencilSize;

  // Sets draw color at load and when user clicks color input


  function setColor(color) {
    if (color == "eraser") {
      drawWithEraser();
    } else {
      drawWithColor(color);
    }
  }
  // Tap the background to switch its color (usefull for transparent images)
  (0, _toggleAbleBackground2.default)(background, { onChange: refreshColorPreviewBorder });

  (0, _pencilSizeSlider2.default)(byId("pensize"), {
    onChange: function onChange(pxSize) {
      setColorDotSize(pxSize);
      setPencilSize(pxSize);
    }
  });

  (0, _canvasMergerAndDonwloaderLink.makeDownloadLink)(byId("download"), {
    OrginalImage: OrginalImage,
    originalFileName: originalFileName,
    canvas: canvas
  });

  (0, _detectCtrlS.detectCtrlS)({
    canvas: canvas,
    OrginalImage: OrginalImage,
    originalFileName: originalFileName
  });

  function clear() {
    clearColorPicker();
  }
}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (pensizePreview, _ref) {
  var onColorChange = _ref.onColorChange,
      elementToContrastWith = _ref.elementToContrastWith,
      canvasForCursor = _ref.canvasForCursor;

  var pensizePreviewDot = pensizePreview.children[0];
  var pensizePreviewBorder = pensizePreview.children[1];

  function refreshColorPreviewBorder() {
    pensizePreviewBorder.style.background = borderColor(currentColor, elementToContrastWith.style.backgroundColor);
  }

  var currentColor = void 0;
  function openInitializedColorPicker() {
    openColorPicker(currentColor, onColorPicked);
  }
  pensizePreview.addEventListener("click", openInitializedColorPicker);
  var previousColor = localStorage.getItem("previousColor") || "eraser";

  function onColorPicked(color) {
    console.log("onColorPicked", color);
    if (currentColor && color !== currentColor) {
      // For toggling between last two colors
      previousColor = currentColor;
    }

    localStorage.setItem("previousColor", previousColor);

    currentColor = color;
    setCursor(canvasForCursor, currentSize, currentColor);
    if (color == "eraser") {
      pensizePreviewDot.style.background = "";
      pensizePreviewDot.classList.add("eraser");
    } else {
      pensizePreviewDot.classList.remove("eraser");
      pensizePreviewDot.style.background = color;
      refreshColorPreviewBorder();
    }
    localStorage.setItem("color", color);
    onColorChange(color);
  }
  var currentSize = void 0;
  // Should be 10
  var baseSize = pensizePreviewDot.getBoundingClientRect().width;

  window.addEventListener("keydown", function (ev) {
    if (String.fromCharCode(ev.which).toLowerCase() === "x") {
      console.log("x switching to " + previousColor);
      onColorPicked(previousColor);
    }
  });

  function setColorDotSize(pxSize) {
    currentSize = pxSize;
    setCursor(canvasForCursor, currentSize, currentColor);
    pensizePreviewDot.style.transform = "scale(" + pxSize / baseSize + ")";
    pensizePreviewBorder.style.transform = "scale(" + (pxSize / baseSize + 1 / baseSize) + ")";
  }

  setTimeout(function () {
    return onColorPicked(localStorage.getItem("color") || DEFAULTCOLOR);
  });

  return {
    clearColorPicker: function clearColorPicker() {
      pensizePreview.removeEventListener("click", openInitializedColorPicker);
    },

    setColorDotSize: setColorDotSize,
    refreshColorPreviewBorder: refreshColorPreviewBorder
  };
};

var _colorToRGB = __webpack_require__(5);

var _palette = __webpack_require__(6);

var _modal = __webpack_require__(7);

var DEFAULTCOLOR = "#2b76ce";


function borderColor(foreground, background) {
  if (foreground == "eraser") return "transparent";
  var bgL = (0, _colorToRGB.luminance)(background);
  var fgL = (0, _colorToRGB.luminance)(foreground);
  if (bgL > 125 && fgL > 200) return "black";
  if (bgL < 125 && fgL < 25) return "white";
  return "transparent";
}

function textColor(background) {
  return (0, _colorToRGB.luminance)(background) > 255 / 2 ? "rgba(0,0,0,0.8)" : "rgba(255,255,255,0.8)";
}

function openColorPicker(currentColor, callback) {
  (0, _modal.createModal)("color-modal", function (_ref2) {
    var modal = _ref2.modal,
        closeModal = _ref2.closeModal;

    function pickColor(color) {
      closeModal();
      callback(color);
    }

    _palette.paletteColors.forEach(function (color) {
      var button = document.createElement("button");
      button.classList.add("colorbutton");
      if (color === currentColor) {
        button.classList.add("active");
        button.innerHTML = "Selected";
        button.style.color = textColor(color);
      }
      button.style.backgroundColor = color.toLowerCase();
      button.addEventListener("click", function () {
        return pickColor(color);
      });
      modal.appendChild(button);
    });

    var eraser = document.createElement("button");
    eraser.classList.add("eraser");
    eraser.addEventListener("click", function () {
      return pickColor("eraser");
    });
    eraser.innerHTML = '<img src="' + __webpack_require__(8) + '"/><span class="imagelabel">' + ("eraser" === currentColor ? "Eraser selected" : "Eraser") + "</span>";
    modal.appendChild(eraser);
  });
}

function setCursor(node, size, color) {
  var s = size < 4 ? 4 : size;
  var c = document.createElement("canvas");
  c.width = c.height = s;
  var ctx = c.getContext("2d");

  if (color == "eraser") drawEraser(ctx, s);else drawColorCircle(ctx, s, color);
  var cursor = c.toDataURL("image/png");
  node.style.cursor = "url(" + cursor + ") " + s / 2 + " " + s / 2 + ",auto";
}

function drawColorCircle(ctx, s, color) {
  ctx.beginPath();
  ctx.arc(s / 2, s / 2, s / 2, 0, 2 * Math.PI, false);
  ctx.fillStyle = color;
  ctx.fill();
}

function drawEraser(ctx, s) {
  ctx.fillStyle = "#da502d";
  ctx.fillRect(0, 0, s * 2 / 3, s);
  ctx.fillStyle = "#6584a5";
  ctx.fillRect(s * 2 / 3 - 1, 0, s, s);
  ctx.globalCompositeOperation = "destination-in";
  drawColorCircle(ctx, s, "white");
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorToRGB = colorToRGB;
exports.luminance = luminance;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function colorToRGB(color) {
  var canvas = document.createElement("canvas");
  canvas.width = canvas.height = 1;
  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, 1, 1);
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, 1, 1);
  return [].concat(_toConsumableArray(ctx.getImageData(0, 0, 1, 1).data)).slice(0, 3);
}

function luminance(color) {
  return colorToRGB(color).reduce(function (a, b) {
    return a + b;
  }, 0) / 3;
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var paletteColors = exports.paletteColors = "#000000,#FFFFFF,#F44336,#E91E63,#9C27B0,#673AB7,#3F51B5,#2196F3,#03A9F4,#00BCD4,#009688,#4CAF50,#8BC34A,#CDDC39,#FFEB3B,#FFC107,#FF9800,#FF5722,#795548,#9E9E9E,#607D8B".split(",");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModal = createModal;
var modalZindex = 4;
function createModal(className, callback) {
  var modal = document.createElement("div");
  modal.classList.add("modal");
  modal.classList.add(className);
  document.body.appendChild(modal);

  var backdrop = document.createElement("div");
  backdrop.classList.add("modal-backdrop");
  document.body.appendChild(backdrop);

  backdrop.style.zIndex = modalZindex;
  modal.style.zIndex = modalZindex + 1;
  backdrop.addEventListener("click", closeModal);
  document.addEventListener("keyup", closeOnEscape);
  function closeOnEscape(ev) {
    if (ev.which == 27 // escape key
    ) closeModal();
  }
  function closeModal() {
    modal.classList.add("closing");
    backdrop.classList.add("closing");
    setTimeout(function () {
      document.body.removeChild(modal);
      document.body.removeChild(backdrop);
    }, 300);
    document.removeEventListener("keyup", closeOnEscape);
  }
  modalZindex += 2;
  return callback({ modal: modal, closeModal: closeModal });
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f585fe2054b88eb6d1e59cdeda7bb5da.svg";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var onImageCreated = _ref.onImageCreated,
      fileinput = _ref.fileinput,
      _ref$startTask = _ref.startTask,
      startTask = _ref$startTask === undefined ? function () {
    return null;
  } : _ref$startTask,
      _ref$endTask = _ref.endTask,
      endTask = _ref$endTask === undefined ? function () {
    return null;
  } : _ref$endTask;

  // Callbacks onImageCreated with img tag and filename
  var originalFileName = "pasted-image";
  var askingForImage = true;

  // Transforms the file input content to a real image
  function loadFile(fileToLoad) {
    startTask();
    var fileReader = new FileReader();
    fileReader.onload = function () {
      createImageWithFileContent(fileReader.result);
      endTask();
    };
    fileReader.onerror = endTask;
    fileReader.readAsDataURL(fileToLoad);
  }

  function createImageWithFileContent(result) {
    startTask();
    if (!askingForImage) return;
    var img = new Image();
    img.onload = function () {
      askingForImage = false;
      onImageCreated(img, originalFileName);
      endTask();
    };
    img.onerror = endTask;
    img.src = result;
  }

  // Setup of the welcome  UI
  function askForImage() {
    fileinput && fileinput.addEventListener("change", fileChanged);
    function fileChanged(changeEvent) {
      fileinput.removeEventListener("change", fileChanged);
      originalFileName = fileinput.value.split("\\").pop().split(".")[0] || "image";
      loadFile(changeEvent.target.files[0]);
    }
  }

  askForImage();

  window.addEventListener("paste", function (ev) {
    handleDataTransferItems(ev.clipboardData.items);
  });

  document.body.addEventListener("dragover", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
  });
  document.body.addEventListener("drop", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    handleDataTransferItems(ev.dataTransfer.items);
  });

  function handleDataTransferItems(items) {
    // Tries to paste an image
    var imageFile = Array.prototype.find.call(items, function (e) {
      return e.kind == "file" && e.type.match("image");
    });
    originalFileName = "pasted-image";
    if (imageFile) {
      loadFile(imageFile.getAsFile());
      return;
    }
    // Tries to load a remote image given its adress
    var url = Array.prototype.find.call(items, function (e) {
      return e.kind == "string";
    });
    if (url) {
      url.getAsString(function (s) {
        return createImageWithFileContent(s);
      });
    }
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (background, _ref) {
  var onChange = _ref.onChange;

  function switchBackground() {
    currentMode++;
    localStorage.setItem("background", currentMode);
    applyBackground();
  }
  var switchCount = 0;
  function applyBackground() {
    var options = ["#DDD", "#333"];
    var current = currentMode % options.length;
    background.style.backgroundColor = options[current];
    // let meta = document.getElementById("theme-color");
    // meta && meta.setAttribute("content", "#fff");
    onChange(current);

    var bclass = document.body.classList;
    options.forEach(function (color, index) {
      return bclass.remove("background_n_" + index);
    });
    bclass.add("background_n_" + current);
    // https://www.youtube.com/watch?v=Pr8ETbGz35Q
    if (switchCount < 8) {
      console.log(current == 0 ? "jour !" : "nuit !");
      switchCount++;
    } else {
      console.log("Monsieur Jacquouille, je vous en prie, à la longue, ça devient casse-pied !");
    }
  }
  var currentMode = localStorage.getItem("background") || 0;
  applyBackground();
  background.addEventListener("click", switchBackground);
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (canvas, _ref) {
  var onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      OrginalImage = _ref.OrginalImage;

  // We cache some zoom related data to avoid getting them all the time
  var scale = void 0,
      rect = void 0,
      lastUsedPXsize = void 0;

  function measureScale() {
    rect = canvas.getBoundingClientRect();
    scale = rect.width / canvas.width;
    if (lastUsedPXsize && ctx) {
      ctx.lineWidth = lastUsedPXsize / scale;
    }
  }
  measureScale();

  window.addEventListener("resize", measureScale);

  var ctx = canvas.getContext("2d");

  // To make the lines look slightly nicer
  ctx.lineCap = "round";

  // We cache the mouse position and previous mouse position.
  // Theay are defined by touch events, and used by the draw loop
  var mousePos = {
    x: 0,
    y: 0
  },
      lastPos = mousePos;

  canvas.addEventListener("mousedown", function (e) {
    if (e.which == 3) {
      // We detected a right click on canvas, probably to save it.
      // We merge the content of the background image with the canvas
      (0, _canvasMergerAndDonwloaderLink.mergeCanvasAndImage)(canvas, OrginalImage);
      return;
    }
    mousePos = lastPos = getMousePos(e);
    startDrawLoop();
    onMouseDown();
  }, false);

  // Allow ctrl-c > pasting to word & co
  document.addEventListener("copy", function (ev) {
    ev.preventDefault();
    (0, _canvasMergerAndDonwloaderLink.mergeCanvasAndImage)(canvas, OrginalImage);
    ev.clipboardData.setData("text/html", '<img src="' + canvas.toDataURL() + '"/>');
  });

  document.addEventListener("mouseup", endDrawLoop, false);

  canvas.addEventListener("mousemove", function (e) {
    mousePos = getMousePos(e);
  }, false);

  // Get the position of the mouse relative to the canvas
  function getMousePos(mouseEvent) {
    return {
      x: (mouseEvent.clientX - rect.left) / scale,
      y: (mouseEvent.clientY - rect.top) / scale
    };
  }

  // Drawing loop is separated from the events￼

  var isDrawing = false;

  function startDrawLoop() {
    if (isDrawing) return;
    isDrawing = true;
    ctx.beginPath();
    drawLoop();
  }
  function endDrawLoop() {
    isDrawing && onMouseUp();
    isDrawing = false;
  }

  function drawLoop() {
    if (isDrawing) {
      window.requestAnimationFrame(drawLoop);
      renderCanvas();
    }
  }
  function renderCanvas() {
    ctx.moveTo(lastPos.x, lastPos.y);
    ctx.lineTo(mousePos.x, mousePos.y);
    ctx.stroke();
    lastPos = mousePos;
  }

  // Proxy mobile events to their mouse counterpart
  function proxyTouchToMouse(touchEventName, mouseEventName) {
    var eventTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : canvas;

    canvas.addEventListener(touchEventName, function (e) {
      e.preventDefault();

      var _ref2 = e.touches[0] || {},
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var mouseEvent = new MouseEvent(mouseEventName, {
        clientX: clientX,
        clientY: clientY
      });
      eventTarget.dispatchEvent(mouseEvent);
    }, false);
  }
  proxyTouchToMouse("touchstart", "mousedown");
  proxyTouchToMouse("touchend", "mouseup", document);
  proxyTouchToMouse("touchmove", "mousemove");

  return {
    drawWithEraser: function drawWithEraser() {
      ctx.globalCompositeOperation = "destination-out";
    },
    drawWithColor: function drawWithColor(color) {
      ctx.globalCompositeOperation = "source-over";
      ctx.strokeStyle = color;
    },
    setPencilSize: function setPencilSize(pxSize) {
      lastUsedPXsize = pxSize;
      ctx.lineWidth = pxSize / scale;
    }
  };
};

var _canvasMergerAndDonwloaderLink = __webpack_require__(0);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (slider, _ref) {
  var onChange = _ref.onChange;

  // Sets draw size at load and style when the user interracts with the slider
  function onPencilSizeChange(pxSize) {
    slider.value = pxSize;
    localStorage.setItem("pensize", pxSize);
    onChange(pxSize);
  }
  slider.addEventListener("input", function (e) {
    return onPencilSizeChange(e.target.value);
  });
  onPencilSizeChange(parseInt(localStorage.getItem("pensize")) || DEFAULTSIZE);
};

var DEFAULTSIZE = 20;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (canvas, _ref) {
  var fitWindow = _ref.fitWindow;

  var ctx = void 0,
      w = void 0,
      h = void 0;
  var bgColor = "#F44336"; //randomColor(darkCoolColors);
  function reset() {
    if (fitWindow) {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    w = canvas.width;
    h = canvas.height;
    ctx = canvas.getContext("2d");
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, w, h);
    ctx.lineCap = "round";
    randomizeInst();
  }

  var position = void 0,
      speed = void 0,
      acceleration = void 0,
      timeoutHandle = void 0,
      accelerationTimeoutHandle = void 0;
  function randomizeInst() {
    position = {
      // x: Math.random() * w,
      // y: Math.random() * h
      x: w / 2,
      y: h / 2
    };
    speed = {
      x: Math.random() * 10 - 5,
      y: Math.random() * 10 - 5
    };
    acceleration = {
      x: Math.random() * 10 - 5,
      y: Math.random() * 10 - 5
    };

    ctx.strokeStyle = randomColor(coolColors, bgColor);
    ctx.lineWidth = 20 + Math.random() * 40;
    ctx.beginPath();
    ctx.moveTo(position.x, position.y);
  }

  reset();
  window.addEventListener("resize", reset);

  function randomAcceletation() {
    acceleration = {
      x: Math.random() * 2 - 1,
      y: Math.random() * 2 - 1
    };
    // speed.x*=0.2;
    // speed.y*=0.2;

    accelerationTimeoutHandle = setTimeout(randomAcceletation, 100 + Math.random() * 200);
  }
  randomAcceletation();
  function renderCanvas() {
    ctx.moveTo(position.x, position.y);
    speed.x *= 0.95;
    speed.y *= 0.95;

    speed.x += acceleration.x;
    speed.y += acceleration.y;
    position.x += speed.x;
    position.y += speed.y;
    ctx.lineTo(position.x, position.y);
    ctx.stroke();
    if (position.x < -50 || position.x > w + 50 || position.y < -50 || position.y > h + 50) randomizeInst();
  }

  var isDrawing = true;
  function drawLoop() {
    if (isDrawing) {
      window.requestAnimationFrame(drawLoop);
      renderCanvas();
    }
  }

  drawLoop();

  function stopAnim() {
    isDrawing = false;
    clearTimeout(accelerationTimeoutHandle);
    window.removeEventListener("resize", reset);
  }

  return {
    stopAnim: stopAnim,
    bgColor: bgColor
  };
};

var coolColors = "#F44336,#E91E63,#9C27B0,#673AB7,#3F51B5,#2196F3,#03A9F4,#00BCD4,#009688,#4CAF50,#8BC34A,#CDDC39,#FFEB3B,#FFC107,#FF9800,#FF5722".split(",");

//import { luminance } from "./colorToRGB.js";
// const darkCoolColors = coolColors.filter(c => luminance(c) < 150);

function randomColor(colorPool) {
  var exception = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var withoutEx = colorPool.filter(function (c) {
    return c != exception;
  });
  return withoutEx[Math.floor(Math.random() * withoutEx.length)];
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startTask = startTask;
exports.endTask = endTask;
exports.updateLook = updateLook;
var tasksInProgress = 0;
function startTask() {
  tasksInProgress++;
  updateLook();
}

function endTask() {
  tasksInProgress--;
  setTimeout(updateLook);
}

function updateLook() {
  spinners.classList[tasksInProgress ? "remove" : "add"]("hidden");
}
document.addEventListener("DOMContentLoaded", updateLook);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectCtrlS = detectCtrlS;

var _canvasMergerAndDonwloaderLink = __webpack_require__(0);

function detectCtrlS(_ref) {
  var canvas = _ref.canvas,
      OrginalImage = _ref.OrginalImage,
      originalFileName = _ref.originalFileName;

  window.addEventListener("keydown", function (event) {
    if (event.ctrlKey || event.metaKey) {
      if (String.fromCharCode(event.which).toLowerCase() === "s") {
        event.preventDefault();
        (0, _canvasMergerAndDonwloaderLink.triggerDownload)(canvas, originalFileName, OrginalImage);
      }
    }
  });
}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var warn = "offline-plugin: runtime was installed without OfflinePlugin being added to the webpack.config.js. See https://goo.gl/2Ca7NO for details.";

if (window.console) {
  if (console.info) {
    console.info(warn);
  } else if (console.log) {
    console.log(warn);
  }
}

exports.install = function() {};
exports.applyUpdate = function() {};
exports.update = function() {};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.2deff698413f939544a8.js